import React from 'react';
import { Box, Typography, Stack } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { ReactComponent as ProactiveIcon } from '../assets/Proactive.svg';
import { ReactComponent as OfferingIcon } from '../assets/Offering.svg';
import { ReactComponent as PartnersIcon } from '../assets/Partners.svg';
import { ReactComponent as LearnIcon } from '../assets/Learn.svg';
import { ReactComponent as TimeAndMoneyIcon } from '../assets/TimeAndMoney.svg';
import { ReactComponent as IntermediariesIcon } from '../assets/Intermediaries.svg';


export const Advantages = () => {
  const { t } = useTranslation();
  const firstRow = [
    {
      title: t('website:plus.advantages.items.proactive.title'),
      text: t('website:plus.advantages.items.proactive.text'),
      icon: <ProactiveIcon />
    },
    {
      title: t('website:plus.advantages.items.developOffering.title'),
      text: t('website:plus.advantages.items.developOffering.text'),
      icon: <OfferingIcon />
    },
    {
      title: t('website:plus.advantages.items.teamUpWithPartners.title'),
      text: t('website:plus.advantages.items.teamUpWithPartners.text'),
      icon: <PartnersIcon />
    },
  ];

  const secondRow = [
    {
      title: t('website:plus.advantages.items.learnFromBest.title'),
      text: t('website:plus.advantages.items.learnFromBest.text'),
      icon: <LearnIcon />
    },
    {
      title: t('website:plus.advantages.items.saveTimeAndMoney.title'),
      text: t('website:plus.advantages.items.saveTimeAndMoney.text'),
      icon: <TimeAndMoneyIcon />
    },
    {
      title: t('website:plus.advantages.items.findIntermediaries.title'),
      text: t('website:plus.advantages.items.findIntermediaries.text'),
      icon: <IntermediariesIcon />
    },
  ];

  return (
    <Stack
     sx={{
      display: "flex",
      gap: 8,
      maxWidth: "100vw",
     }}
    >
      <Stack gap={2} flexDirection={{xs: "column", md: "row"}} sx={{mx: {xs:4, md: 0}}}>      
        <Typography
          flex={1}
          variant='h2'
          sx={{
            fontSize: "2.5rem",
            fontWeight: 600,
            lineHeight: 1.25,
            alignSelf: "center",
            textAlign: {xs: "center", md: "start"},
          }}
        >
          {t('website:plus.advantages.heading')}
        </Typography>
        <Stack
          flex={1}
          gap={1}
          sx={{
            '& p': {
              color: "rgba(0, 0, 0, 0.70)",
              fontSize: "1rem",
              fontWeight: 400,
              lineHeight: 1.5,
            }
          }}
        >
          <Typography variant='body2'>
            {t('website:plus.advantages.description1')}
          </Typography>
          <Typography variant='body2'>
            {t('website:plus.advantages.description2')}
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{mx: {xs:4, md: 0}}}>
        <Stack flexDirection={{xs: "column", md: "row"}}>
          {firstRow.map((item, index) => (
            <Stack
              key={item.title}
              flex={1}
              sx={{
                py: 3,
                px: {xs: 0, md: 3},
                gap: 1,
                border: '1px solid #F1F1F1',
                borderLeft: {xs: 'none', md: index === 0 ? 'none' : '1px solid #F1F1F1'},
                borderRight: {xs: 'none', md: index === secondRow.length - 1 ? 'none' : '1px solid #F1F1F1'},
              }}
            >
              <Box
                width={58}
                height={58}
              >
                {item.icon}
              </Box>
              <Typography
                variant='body1'
                sx={{
                  textTransform: "uppercase",
                  color: "text.custom",
                  lineHeight: 1.6,
                  fontSize: "1.25rem",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#4D4D4D",
                  lineHeight: 1.5,
                  fontSize: "1rem",
                  fontWeight: 400
                }}
              >
                {item.text}
              </Typography>
            </Stack>
          ))}
        </Stack>
        <Stack flexDirection={{xs: "column", md: "row"}}>
          {secondRow.map((item, index) => (
            <Stack
              key={item.title}
              flex={1}
              sx={{
                py: 3,
                px: {xs: 0, md: 3},
                gap: 1,
                border: '1px solid #F1F1F1',
                borderLeft: {xs: 'none', md: index === 0 ? 'none' : '1px solid #F1F1F1'},
                borderRight: {xs: 'none', md: index === secondRow.length - 1 ? 'none' : '1px solid #F1F1F1'},
              }}
            >
              <Box
                width={58}
                height={58}
              >
                {item.icon}
              </Box>
              <Typography
                variant='body1'
                sx={{
                  textTransform: "uppercase",
                  color: "text.custom",
                  lineHeight: 1.6,
                  fontSize: "1.25rem",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#4D4D4D",
                  lineHeight: 1.5,
                  fontSize: "1rem",
                  fontWeight: 400
                }}
              >
                {item.text}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}